var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftOrnament(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 135.244,
    height: 666.497,
    viewBox: "0 0 135.244 666.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    y1: 1.171,
    x2: 0.5,
    y2: 2.7,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edd47a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#776a3d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.947,368.869v79.417h12.68V368.869a121.725,121.725,0,0,0-36.038-86.494l-52.716-52.6v17.923l43.749,43.645A109.139,109.139,0,0,1,280.947,368.869Z",
    transform: "translate(-204.874 -155.485)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.437,393.2v107.31h12.681V393.2a121.739,121.739,0,0,0-36.038-86.5l-99.205-98.993v17.933l90.239,90.027A109.139,109.139,0,0,1,327.437,393.2Z",
    transform: "translate(-204.874 -207.708)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(76.074 287.989)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.679,
    height: 395,
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 12.679,
    height: 395,
    transform: "translate(46.49 0)",
    fill: "url(#a)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftOrnament);
export default __webpack_public_path__ + "static/media/left_ornament.5442c91ea68ac163d814de7d2d082ddc.svg";
export { ForwardRef as ReactComponent };